module.exports = __webpack_public_path__ + "img/1868-14th Amendment-cropped.cc28b9df.jpg";